import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/tag.js";
import "@ui5/webcomponents-icons/dist/decision.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/document-text.js";
import "@ui5/webcomponents-icons/dist/qr-code.js";
import "@ui5/webcomponents-icons/dist/table-view.js";

import { taxPermissions } from "./permissions";

/** Tax report routes (`/tax/reports/<key>`) and the permission of each. */
export const taxReports = {
  "tax-ledger": taxPermissions.taxLedgerView,
  reconciliation: taxPermissions.reconciliationView,
  withholding: taxPermissions.withholdingReportView,
} as const;
export type TaxReportKey = keyof typeof taxReports;
export const taxReportKeys = Object.keys(taxReports) as TaxReportKey[];

const reportLabel: Record<TaxReportKey, string> = {
  "tax-ledger": "nav.taxReportLedger",
  reconciliation: "nav.taxReportReconciliation",
  withholding: "nav.taxReportWithholding",
};

/** Tax entries of the navigation registry (group `tax`, plan module `tax`). */
export const taxNavigation: readonly NavigationEntry[] = [
  {
    key: "tax.returns",
    labelKey: "nav.taxReturns",
    icon: "document-text",
    path: "/tax/returns",
    permission: taxPermissions.returnView,
  },
  {
    key: "tax.einvoices",
    labelKey: "nav.taxEInvoices",
    icon: "qr-code",
    path: "/tax/einvoices",
    permission: taxPermissions.eInvoiceView,
  },
  { key: "tax.codes", labelKey: "nav.taxCodes", icon: "tag", path: "/tax/codes", permission: taxPermissions.codeView },
  {
    key: "tax.determination",
    labelKey: "nav.taxDetermination",
    icon: "decision",
    path: "/tax/determination",
    permission: taxPermissions.determinationView,
  },
  {
    key: "tax.settings",
    labelKey: "nav.taxSettings",
    icon: "settings",
    path: "/tax/settings",
    permission: taxPermissions.settingsView,
  },
  ...taxReportKeys.map((report) => ({
    key: `tax.report.${report}`,
    labelKey: reportLabel[report],
    icon: "table-view",
    path: `/tax/reports/${report}`,
    permission: taxReports[report],
  })),
];
